import { api } from "../../lib/api";
import { getToken } from "../../storage/auth";
import { InvoiceNote } from "../../types/invoiceNote";
import { PartnerService } from "../../types/partner";

const entity = "invoice-notes";

export const create = async (
  note: Partial<InvoiceNote>,
): Promise<PartnerService> => {
  const token = getToken()
  const { data } = await api.post(`/${entity}`, note, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
  return data
}

export const remove = async (
  ID_INVOICE_NOTA: number,
  forceDelete?: boolean
): Promise<PartnerService> => {
  const token = await getToken()
  const { data } = await api.delete(`/${entity}/${ID_INVOICE_NOTA}`, {
    data: {
      forceDelete,
    },
    headers: { authorization: `Bearer ${token}` },
  })
  return data
}
